export const FIND_MY_MODEL_DATA = [
  {
    id: 1,
    title: 'Réglages',
    description: 'Ouvrez l\'application Réglages de votre appareil.',
    steps: [
      'Déverrouillez votre smartphone iPhone ou Android.',
      'Recherchez l\'icône de l\'application <strong class="text-indigo-600">Réglages</strong> (généralement représentée par une roue crantée).',
      'Appuyez dessus pour ouvrir les paramètres globaux de votre téléphone.'
    ],
    image: '',
    alt: 'Ouvrir l\'application Réglages'
  },
  {
    id: 2,
    title: 'Général',
    description: 'Accédez à la section Général ou Système de votre appareil.',
    steps: [
      'Faites défiler vers le bas pour trouver l\'option <strong class="text-indigo-600">Général</strong> sur iOS, ou <strong class="text-indigo-600">Système / À propos du téléphone</strong> sur Android.',
      'Appuyez sur cette section pour afficher les options d\'administration.'
    ],
    image: '',
    alt: 'Section Général ou À propos'
  },
  {
    id: 3,
    title: 'Informations',
    description: 'Sélectionnez Informations pour voir les détails de votre smartphone.',
    steps: [
      'Sur iPhone, appuyez sur <strong class="text-indigo-600">Informations</strong> tout en haut de l\'écran.',
      'Sur Android, cette étape est souvent fusionnée avec l\'onglet "À propos du téléphone" qui répertorie directement vos spécifications matérielles.'
    ],
    image: '',
    alt: 'Accéder aux informations système'
  },
  {
    id: 4,
    title: 'Nom du modèle',
    description: 'Recherchez le nom exact et le numéro de modèle.',
    steps: [
      'Localisez la ligne <strong class="text-indigo-600">Nom du modèle</strong> ou <strong class="text-indigo-600">Numéro de modèle</strong>.',
      'Vous y verrez apparaître par exemple « iPhone 14 Pro » ou « Galaxy S23 », ainsi que la référence exacte (ex. : modèle A2890).',
      'Prenez note de ces informations indispensables avant de commander votre réparation ou de demander une estimation.'
    ],
    image: '',
    alt: 'Identifier le nom et le numéro de modèle'
  }
];
